import React from 'react'

import webbg from "../assets/img/webbg.png";
import webbg2 from "../assets/img/webbg2.png";
import staranimate from "../assets/img/staranimate.png";
import eli2 from "../assets/img/eli2.png";
import aboutus1 from "../assets/img/about-us1.jpg";
import malhanos from "../assets/img/malhanos.png";
import cosmicRitika from "../assets/img/cosmic-ritika.png";
import ajytransworld from "../assets/img/ajytransworld.png";
import jollyuncle from "../assets/img/jollyuncle.png";
import swayambhu from "../assets/img/swayambhu.png";
import geartechnologies from "../assets/img/geartechnologies.png";
import { Link } from 'react-router-dom';

import { Helmet } from "react-helmet-async";


export default function Websit() {
  return (
    <>

	<Helmet>
		<title>Website designing company in Ghaziabad</title>
		<meta name="description" content="Professional web design services in Ghaziabad. Get responsive, user-friendly websites designed to help your business develop online. Contact us immediately!" />
	</Helmet>
    {/* banner start */}
    <section className="inntepagesection">
	    <div className="outerofinnterpage" style={{
                backgroundImage: `url(${webbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            >
            <div className="background-overlay overlay-about-bnr"></div>
            <div className="container">
                <div className="innerpagecontent">
                    <div className="staranimate starimages2">
                        <img src={staranimate} alt='star icon' />
                    </div>
                    <h1>Website Development Packages</h1>
                    <ul>
                        <li>
                            <Link to="/">Home <span></span></Link>
                        </li>
                        <li>
                            <Link to="/website-development">website development</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
        
     {/* Web Design and Web Development Packages */}
    <section className="sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}
        >
        <div className="background-overlay overlay-about-us"></div>
        <div className="overlayset2 about-us-page" style={{
            backgroundImage: `url(${eli2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}
        >
        </div>
        <div className="outerofabout">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="aboutcontent">
                            <div className="imgofabout-us">
                                <img src={aboutus1} alt="about us" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="aboutcontent-two">
                            <div className="sectionheading sectiofheading">
                                <h2>Web Design and <span>Web Development Packages</span></h2>
                            </div>
                            <p className="sectioncontent">Would you be interested in establishing a strong online presence? At stockcod, we specialize in creating unique websites that align with your business objectives. Our team creates user-friendly, responsive websites that look excellent on all devices, including computers and smartphones.</p>
                            <p>We provide custom design solutions that are specific to your brand, ensuring that your website stands out. We offer e-commerce development services to organizations wishing to sell online, including secure payment gateways, shopping carts, and order management.</p>
                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <p>We also offer content management systems (CMS) such as WordPress, which allow you to simply update content and administer your website without requiring technical knowledge. If you require more complicated solutions, we may provide custom web applications to optimize your company processes.
                        Why pick us? Our website creation packages start at <span className="text-white">₹5999</span> and include one year of free hosting. Our skilled developers use cutting-edge technologies to ensure that your website is both functional and future-proof.</p>
                        <p>Following the launch, we provide continuous support and maintenance to ensure that your website is updated, secure, and running optimally.</p>

                        <p>Ready to take your business online? Please contact us right away to have a professional website that will help you reach new customers and build your brand.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    {/* form  */}
    <section className="sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}>
        <div className="background-overlay overlay-about-us"></div>
        <div className="overlayset2 about-us-page" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}>
        </div>
        <div className="container">
            <div className="developmentform developmentform">
                <div className="contactform">
                    <div className="sectionheading text-center">
                        <h2>Start Your <span>Project</span></h2>
                    </div>
                    <form action="form.php" method="POST" id="emailForm">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-12">
                                <div className="mb-3 mt-3">
                                    <input type="text" className="form-control" id="name" placeholder="Enter Name" name="name" required="" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-12">
                                <div className="mb-3 mt-3">
                                    <input type="email" className="form-control" id="email" placeholder="Enter Email Id" name="email" required="" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-12">
                                <div className="mb-3 mt-3">
                                    <input type="number" className="form-control" id="contact" placeholder="Enter Phone Number" name="contact" required="" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-12">
                                <div className="mb-3 mt-3">
                                    <button type="submit" className="btn btn-primary mt-0" id="SubmitBtn" name="SubmitBtn">Send Message</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>

    {/* package */}


    <section  className="servsection sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}
        >
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            >
				</div>
    	<div className="outerofservices">
    		<div className="container">
    			<div className="sectionheading heading-mb">
					<h2>Website Design <span>Packages</span></h2>
				</div>
				<div className="row rowcontent justify-content-center">
					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">Startup</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
									₹5,999
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">5 Pages</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">1 Contact Form With Enquiry Form Popup</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">5 Times Changes</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 30 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">Small Business</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
								₹15,000
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Upto 10 Pages</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Logo</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Dynamic Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Login Details Will be Given</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">2 Contact Form</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">1 Email ID</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Whatsap & Call Button</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Testimonials</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">7 Times Changes</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 60 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>

					<div className="col-lg-4 col-md-8 col-sm-12 serouterbox">
						<div className="servicebox2">
							<div className="servicecontent">
								<h2 className="headingcontent">E-Commerce</h2>
							</div>
							<div className="servicecontentamount">
								<h2 className="headingcontent">
									₹21,000
								</h2>
								<p className="phracontent">EXCLUSIVE OF ALL TAXES</p>                     
							</div>
							<div className="icon-list">
								<ul>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Logo</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">10 Product Add</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Mobile Responsive</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WhatsApp & Call Button Integration</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">WordPress Login Details Will be Given</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Payment Gateway International</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Slider</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Dynamic Website</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Testimonials</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Gallery Section</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Content - 1 Rs per word</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Social Profile Link</span></li>
									<li><i className="fa fa-check" aria-hidden="true"></i> <span className="elementor-icon">Technical Support 60 days</span></li>
								</ul>
							</div>
							<div className="webbtn button-icon">
								<a href="#!" data-bs-toggle="modal" data-bs-target="#en">Enquiry Now</a>
							</div>
						</div>
					</div>
				</div>
    		</div>
    	</div>
    </section>
   
    {/* Our Process */}
	<section className="servsection sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}
        >
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            >
        </div>
		<div className="outerofservices">
			<div className="container">
				<div className="sectionheading heading-mb">
					<h2>Our <span>Process</span></h2>
				</div>
				<div className="row">
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Initial consultation</h3>
								<p>To comprehend the vision for your website, we first examine your business needs and goals.</p>
								
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Project Planning</h3>
								<p>A comprehensive strategy is devised, which includes the website's structure, design direction, and necessary functionality.</p>
								
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Design and Approval</h3>
								<p>Our staff designs an individualized layout that suits your brand, and we seek your approval before proceeding.</p>
								
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Development</h3>
								<p>The approved design is developed into a fully working website using cutting-edge technologies and coding techniques.</p>
								
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Test and Review</h3>
								<p>We rigorously test the website's usability, performance, and compatibility on all devices and browsers.</p>
								
							</div>
						</div>
					</div>
					<div className="col-lg-4 col-md-6 col-sm-12 serouterbox">
						<div className="servicebox">
							<div className="sericon">
								
							</div>
							<div className="sercontent">
								<h3>Launch and Support</h3>
								<p>Following launch, we provide continuous support and maintenance to ensure that your website remains up to date and working efficiently.</p>
								
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="outerofcounterdown about-us-counter">
			<div className="count-area" data-diff="100">
			    <div className="container">
			        <div className="row">
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">2</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Year of Experience</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">80</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Happy Client</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">150</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Complete Project</div>
			                </div>
			            </div>
			            <div className="col-sm-6 col-md-3 achivmentouterbox">
			                <div className="count-area-content">
			                	<div className="counterbox">
				                    <div className="count-digit">10</div>
				                    <span>+</span>
				                </div>
			                    <div className="count-title">Team Members</div>
			                </div>
			            </div>
			        </div>
			    </div>
			  </div>
		</div>
		</div>
	</section>

	<section className="servsection sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}>
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}>
		</div>
		<div className="packages">
		<div className="container">
			<div className="sectionheading heading-mb">
				<h2>Our <span>Project</span></h2>
			</div>
			<div className="row justify-content-center" >
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={malhanos} alt="Clients" />
						<h4>Malhanos Trade Services</h4>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={cosmicRitika} alt="Clients" />
						<h4>Cosmic Ritika</h4>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={ajytransworld} alt="Clients" />
						<h4>Ajy Transworld</h4>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={jollyuncle} alt="Clients" />
						<h4>Jolly Uncle</h4>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={swayambhu} alt="Clients" />
						<h4>Swayambhu</h4>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 ourprojectbox">
					<div className="projectboxset">
						<img src={geartechnologies} alt="Clients" />
						<h4>Gear Technologies</h4>
					</div>
				</div>
			</div>
		</div>
		</div>
	</section>
	<section className="servsection sectionpadding" style={{
            backgroundImage: `url(${webbg2})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }}>
		<div className="background-overlay overlay-service"></div>
		<div className="overlayset2" style={{
                backgroundImage: `url(${eli2})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}
            >
		</div>
		<div className="container p-4 ">
			<div className="accordion accordion-flush" id="accordionFlushExample">
			    <div className="sectionheading heading-mb" style={{
                    position: 'relative',
                    width: '100%',
                }}
                >
					<h2>Frequently Asked <span>Questions?</span></h2>
				</div>
			    <div className="accordion-item rounded-3 border-0 shadow mb-2">
			      <h2 className="accordion-header">
			        <button className="accordion-button collapsed fw-semibold frequent" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" style={{
                        backgroundColor: '#212529',
                        color: '#fff',
                    }} 
                    >
			          How long does it take to create a website?
			        </button>
			      </h2>
			      <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{
                    backgroundColor: ' #212529',
                    color: '#fff',
                    position: 'relative',
                  }}
                  >
			        <div className="accordion-body">
			          <p>Website development timelines are determined by the project's complexity. A simple website usually takes 2-4 weeks, however, more complicated sites, such as e-commerce or specialized web apps, can take 4-8 weeks or longer.</p>
			        </div>
			      </div>
			    </div>
			    <div className="accordion-item rounded-3 border-0 shadow mb-2">
			      <h2 className="accordion-header">
			        <button className="accordion-button frequent collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo" style={{
                        backgroundColor: '#212529',
                        color: '#fff',
                    }}>
			           Will my website be mobile-friendly?
			        </button>
			      </h2>
			      <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{
                    backgroundColor: ' #212529',
                    color: '#fff',
                    position: 'relative',
                  }}>
			        <div className="accordion-body">
			          <p>Yes! We ensure that all of our websites are totally responsive, which means they will perform seamlessly on mobile devices, tablets, and desktop computers. This improves user experience and ensures that your website is available across all platforms.</p>
			        </div>
			      </div>
			    </div>
			    <div className="accordion-item rounded-3 border-0 mb-2 shadow">
			      <h2 className="accordion-header">
			        <button className="accordion-button frequent collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree" style={{
                        backgroundColor: '#212529',
                        color: '#fff',
                    }}
                    >
			          Can I update the website after it is built?
			        </button>
			      </h2>
			      <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample"style={{
                    backgroundColor: ' #212529',
                    color: '#fff',
                    position: 'relative',
                  }}
                  >
			        <div className="accordion-body">
			          <p>Absolutely. We provide websites with content management systems (CMS) such as WordPress, which allow you to effortlessly change text, photos, and other content without requiring technical skills.</p>
			        </div>
			      </div>
			    </div>
			        <div className="accordion-item rounded-3 border-0 shadow mb-2">
			      <h2 className="accordion-header">
			        <button className="accordion-button frequent collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefour" aria-expanded="false" aria-controls="flush-collapsefour" style={{
                        backgroundColor: '#212529',
                        color: '#fff',
                    }}
                    >
			           How much does web development cost?
			        </button>
			      </h2>
			      <div id="flush-collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{
                    backgroundColor: ' #212529',
                    color: '#fff',
                    position: 'relative',
                  }}
                  >
			        <div className="accordion-body">
			          <p>The pricing varies according to the type of website you require. Simple websites start at ₹5999, but sophisticated features like e-commerce or custom apps would boost the cost. We will send a full price once we understand your exact needs.</p>
			        </div>
			      </div>
			    </div>
			    <div className="accordion-item rounded-3 border-0 shadow mb-2">
			      <h2 className="accordion-header">
			        <button className="accordion-button frequent collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefive" aria-expanded="false" aria-controls="flush-collapsefive" style={{
                        backgroundColor: '#212529',
                        color: '#fff',
                    }}
                    >
			          Do you provide website maintenance after launch?

			        </button>
			      </h2>
			      <div id="flush-collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample" style={{
                    backgroundColor: ' #212529',
                    color: '#fff',
                    position: 'relative',
                  }}
                  >
			        <div className="accordion-body">
			          <p>Yes, we offer continuing support and maintenance services. This includes updates, security checks, backups, and technical support to ensure that your website continues to function properly after launch.</p>
			        </div>
			      </div>
			    </div>
			</div>
		</div>
	</section>
    </>
  )
}
